import { render, staticRenderFns } from "./user-coupon-bind.vue?vue&type=template&id=3566b8b2&scoped=true"
import script from "./user-coupon-bind.vue?vue&type=script&lang=js"
export * from "./user-coupon-bind.vue?vue&type=script&lang=js"
import style0 from "./user-coupon-bind.vue?vue&type=style&index=0&id=3566b8b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3566b8b2",
  null
  
)

export default component.exports